var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mdc-button",class:{
    'mdc-button--raised': _vm.raised,
    'mdc-button--dense': _vm.dense,
    secondary: _vm.secondary && _vm.raised,
    danger: _vm.danger,
  },attrs:{"disabled":_vm.disabled,"type":"button"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }